import React, { useEffect, useState } from 'react';
import { mapPageIds } from 'constants/test-constants';
import { capitalizeWords } from '@zoocasa/node-kit/strings/capitalize';
import styles from './style.module.scss';
import { useFeaturesContext, useThemeContext, useUserContext } from 'contexts';
import replaceFrenchAccents from 'utils/replace-french-accents';
import { getTenantById } from '@tenants';

import type { ProvinceAndState } from 'utils/province_or_state';
import type { IUserLocation } from 'utils/user-location';
import type { LinkDataType } from 'components/home-page/internal-links';
import generateCityFooterData, { NEARBY_CITIES_IDX } from 'components/pages/area-listings/generate-dynamic-footer-data';

export default function NearbyAreas() {
  const [areas, setAreas] = useState<LinkDataType['links']>([]);
  const { userLocation } = useUserContext();
  const { features } = useFeaturesContext();
  const { tenantId } = useThemeContext(); // FIXME: probably not needed as I think this is only accessed by Zoocasa blog
  const tenant = getTenantById(tenantId);
  useEffect(() => {
    const getPopularNearbyAreas = async (location: IUserLocation) => {
      const splitSlug = location.slug.split('-');
      const slug = location.slug;
      const province = splitSlug[splitSlug.length - 1].toUpperCase() as keyof typeof ProvinceAndState;
      const area = capitalizeWords(splitSlug.slice(0, -1).join(' '));
      const data = await generateCityFooterData(area, slug, tenant, province, 12, features.useLegacySearchFilter || false, false);
      const popularNearbyCities = data[NEARBY_CITIES_IDX].links;
      setAreas(popularNearbyCities);
    };
    if (userLocation) {
      getPopularNearbyAreas(userLocation);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userLocation, features.useLegacySearchFilter]);

  return (
    <div className={styles.component} data-testid={mapPageIds.nearbyAreas}>
      <div className={styles.header}>
        <h2>Popular Nearby Areas</h2>
      </div>
      <div className={styles.grid}>
        {areas.map((area, index) => (<a key={index} href={replaceFrenchAccents(area.link)} target="_blank" rel="noreferrer">{area.label}</a>))}
      </div>
    </div>
  );
}
